import { GenieIcon } from "@/components/ui/genie-icons/GenieIcon";

interface AIAssistantButtonProps {
  onClick: () => void;
  compact?: boolean;
}

const AIAssistantButton = ({ onClick, compact = false }: AIAssistantButtonProps) => (
  <button
    onClick={onClick}
    title="Genie Edit and Review"
    className="group relative overflow-hidden bg-gradient-to-r from-genie-primary to-genie-secondary rounded-full shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105"
  >
    <div className={`flex items-center justify-center transition-all duration-300 ${compact ? 'px-3 py-1.5' : 'px-4 py-1.5'}`}>
      <div className="flex-shrink-0 flex items-center">
        <GenieIcon
          name="lightbulb"
          size={compact ? 16 : 18}
          color="#FFFFFF"
          className="transition-transform group-hover:scale-110"
        />
      </div>
      <span className={`whitespace-nowrap text-white font-semibold transition-all duration-300 ${compact ? 'ml-1.5 text-sm' : 'ml-2 text-sm'}`}>
        {compact ? 'Quick Edit' : 'Genie Edit and Review'}
      </span>
    </div>
  </button>
);

export default AIAssistantButton;
